const createGrid = () => `<svg viewBox="0 256 256" width="256" height="256" xmlns="http://www.w3.org/2000/svg">
  <rect x="125" y="125" height="6" width="6" fill="black"/>
</svg>`;

export default createGrid;